import { createContext, useContext, useState } from "react";
import { erpApi } from "../services/erpApi";

const AuthContext = createContext(null);

function readJson(key) {
  try {
    const saved = localStorage.getItem(key);
    return saved ? JSON.parse(saved) : null;
  } catch {
    localStorage.removeItem(key);
    return null;
  }
}

export function AuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem("clinic_erp_token"));
  const [user, setUser] = useState(() => readJson("clinic_erp_user"));
  const [clinic, setClinic] = useState(() => readJson("clinic_erp_clinic"));

  const persistSession = (response) => {
    localStorage.setItem("clinic_erp_token", response.data.access_token);
    localStorage.setItem("clinic_erp_user", JSON.stringify(response.data.user));
    if (response.data.clinic) {
      localStorage.setItem("clinic_erp_clinic", JSON.stringify(response.data.clinic));
    } else {
      localStorage.removeItem("clinic_erp_clinic");
    }
    setToken(response.data.access_token);
    setUser(response.data.user);
    setClinic(response.data.clinic || null);
  };

  const login = async (payload) => {
    const response = await erpApi.login(payload);
    persistSession(response);
  };

  const signup = async (payload) => {
    const response = await erpApi.signup(payload);
    persistSession(response);
  };

  const logout = async () => {
    try {
      await erpApi.logout();
    } catch {
      // Token cleanup should still happen even if the server is unavailable.
    }
    localStorage.removeItem("clinic_erp_token");
    localStorage.removeItem("clinic_erp_user");
    localStorage.removeItem("clinic_erp_clinic");
    setToken(null);
    setUser(null);
    setClinic(null);
  };

  const updateClinicSession = (nextClinic) => {
    if (nextClinic) {
      localStorage.setItem("clinic_erp_clinic", JSON.stringify(nextClinic));
      setClinic(nextClinic);
    }
  };

  const value = { token, user, clinic, login, signup, logout, updateClinicSession, isAuthenticated: Boolean(token) };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
